import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { openAuthModal } from 'store/parts/auth-modal/actions';

const propTypes = {
  className: PropTypes.string,
  loginRedirectUrl: PropTypes.string,
  defaultForm: PropTypes.PropTypes.oneOf([
    'login',
    'forgot-password',
    'find-your-username'
  ]),
  children: PropTypes.node,
  // store
  openAuthModal: PropTypes.func.isRequired
};

const AuthModalButton = ({
  className,
  loginRedirectUrl,
  defaultForm,
  children,
  openAuthModal
}) => {
  return (
    <button
      className={classnames('btn', 'btn-primary', className)}
      onClick={() =>
        openAuthModal({ loginRedirectUrl, currentForm: defaultForm })
      }
    >
      {children || 'Member Login'}
    </button>
  );
};

AuthModalButton.propTypes = propTypes;

export default connect(null, { openAuthModal })(AuthModalButton);
